<template>
    <div class="rot180">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
            style="margin: auto; background: rgb(0, 0, 0, 0); display: block; shape-rendering: auto;"
            v-bind:width="lwidth < 100 ? lwidth : 100" v-bind:height="lheight < 100 ? lheight : 100"
            viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">

            <g transform="rotate(144 50 50)">
                <rect x="5" y="33.5" rx="3.6" ry="3.5" width="90" height="7" fill="#d62e2e">
                    <animate attributeName="opacity" values="1;0.4" keyTimes="0;1" dur="2s" begin="-1.6s"
                        repeatCount="indefinite"></animate>
                </rect>
            </g>
            <g transform="rotate(0 50 50)">
                <rect x="5" y="33.5" rx="3.6" ry="3.5" width="90" height="7" fill="#d62e2e">
                    <animate attributeName="opacity" values="1;0.4" keyTimes="0;1" dur="2s" begin="-1.7s"
                        repeatCount="indefinite"></animate>
                </rect>
            </g>

            <g transform="rotate(216 50 50)">
                <rect x="5" y="33.5" rx="3.6" ry="3.5" width="90" height="7" fill="#d62e2e">
                    <animate attributeName="opacity" values="1;0.4" keyTimes="0;1" dur="2s" begin="-1.8s"
                        repeatCount="indefinite"></animate>
                </rect>
            </g>
            <g transform="rotate(72 50 50)">
                <rect x="5" y="33.5" rx="3.6" ry="3.5" width="90" height="7" fill="#d62e2e">
                    <animate attributeName="opacity" values="1;0.4" keyTimes="0;1" dur="2s" begin="-1.9s"
                        repeatCount="indefinite"></animate>
                </rect>
            </g>
            <g transform="rotate(288 50 50)">
                <rect x="5" y="33.5" rx="3.6" ry="3.5" width="90" height="7" fill="#d62e2e">
                    <animate attributeName="opacity" values="1;0.4" keyTimes="0;1" dur="2s" begin="-2s"
                        repeatCount="indefinite"></animate>
                </rect>
            </g>
            <g>
                <circle cx="50" cy="50" r="45" stroke="#d62e2e" stroke-width="7" fill="none">
                    <animate attributeName="opacity" values="0.8;0.4" keyTimes="0;1" dur="2s" begin="-2s"
                        repeatCount="indefinite"></animate>
                    <animate attributeName="stroke-width" values="7;3" keyTimes="0;1" dur="2s" begin="-2s"
                        repeatCount="indefinite"></animate>
                    <animate attributeName="r" values="48;43" keyTimes="0;1" dur="2s" begin="-2s"
                        repeatCount="indefinite"></animate>
                </circle>
            </g>
            <g>
                <circle cx="50" cy="50" r="40" stroke="#d62e2e" stroke-width="7" fill="none">
                    <animate attributeName="opacity" values="0.6;0.1" keyTimes="0;1" dur="2s" begin="-2s"
                        repeatCount="indefinite"></animate>
                    <animate attributeName="stroke-width" values="12;3" keyTimes="0;1" dur="2s" begin="-2s"
                        repeatCount="indefinite"></animate>
                    <animate attributeName="r" values="30;55" keyTimes="0;1" dur="2s" begin="-2s"
                        repeatCount="indefinite"></animate>
                </circle>
            </g>
        </svg>
    </div>
</template>

<script>
export default {
    name: "LoadingComp"
    , props: ['lwidth', 'lheight']
    , data() {
        return {
            // lwidth: "287px"
            // , lheight: "287px"
        }
    }
}
</script>

